import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import { FaSignOutAlt, FaBars, FaUser, FaUserLock, FaUserShield, FaPhoneAlt, FaUnlockAlt } from "react-icons/fa";
import { LuLayoutDashboard } from "react-icons/lu";
import { MdQuiz, MdManageAccounts, MdContactSupport, MdMenuBook } from "react-icons/md";
import { signOut, setPersistence, browserSessionPersistence } from "firebase/auth";
import { collection, query, where, getDocs } from "firebase/firestore";
import { db, auth } from "../Firebase_Config/firebase";
import { IoIosArrowDown, IoIosArrowUp, IoIosDocument } from "react-icons/io";
import { BsStars, BsList  } from "react-icons/bs";
import { AiFillSecurityScan, AiFillProfile  } from "react-icons/ai";
import { SiLetsencrypt } from "react-icons/si";
import { LuBrainCircuit } from "react-icons/lu";
import { PiBooksFill } from "react-icons/pi";
import { GiSwordsEmblem } from "react-icons/gi";
import "./sidebar.css";

const Sidebar = ({ user, setUser }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isGuidelinesOpen, setIsGuidelinesOpen] = useState(false);
  const [activeMenu, setActiveMenu] = useState('');
  const [dashboardOpen, setDashboardOpen] = useState(null);
  const [adminTrue, setAdminTrue] = useState(null);

  const toggleSidebar = () => setIsOpen(!isOpen);
  const toggleGuidelines = () => {
    setIsGuidelinesOpen(!isGuidelinesOpen);
    setActiveMenu(isGuidelinesOpen ? '' : 'AI_Guidelines'); // Set active when guidelines open
  };

  const handleMenuClick = (menuName) => {
    setActiveMenu(menuName);
  };

  const handleSignOut = () => {
    setPersistence(auth, browserSessionPersistence)
      .then(() => signOut(auth))
      .then(() => {
        console.log("User signed out and session cleared");
        setUser(null);
      })
      .catch((error) => console.error("Error during sign out:", error.message));
  };

  useEffect(() => {
    const fetchDash = async () => {
      try {
        const userId = auth.currentUser?.uid;
        if (!userId) return;

        const userDocQuery = query(collection(db, "users"), where("userId", "==", userId));
        const userDocSnapshot = await getDocs(userDocQuery);

        if (!userDocSnapshot.empty) {
          const userDocData = userDocSnapshot.docs[0].data();
          setDashboardOpen(userDocData.isThreatComplete || null);
          setAdminTrue(userDocData.isAdmin || null);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchDash();
  }, [user]);

  return (
    <>
      <div className={`sidebar ${isOpen ? "open" : ""}`}>
        <nav>
          <div className="logo-container">
            <img src="TRAMS_LOGO_FINAL.png" alt="TRAMS-AI" />
          </div>
          <hr />
          <ul>
            {/* AI Guidelines Collapsible Section */}
            <li 
              className={`menu-item  ${isGuidelinesOpen || activeMenu === 'AI_Guidelines' ? 'active' : ''}`} 
              onClick={toggleGuidelines}
            >
             
                {isGuidelinesOpen ? <IoIosArrowUp className="icon" /> : <IoIosArrowDown className="icon" />}
                <span>AI Guidelines</span>
              
            </li>
            {isGuidelinesOpen && (
              <ul className="submenu">
                {["Accountability", "Transparency", "Fairness", "Reliability", "Privacy", "Inclusiveness", "Risk_Management", "Impact", "Data_Quaility_Framework"].map((item) => (
                  <li key={item}>
                    <NavLink
                      to={`/${item}`}
                      className={`menu-item `}
                      
                    >
                      <PiBooksFill className="icon" />
                      <span>{item.replace(/_/g, " ")}</span>
                    </NavLink>
                  </li>
                ))}
              </ul>
            )}
            <li>
                <NavLink 
                  to="/ConformityAnalysis" 
                  className={`menu-item `} 
                >
                  <MdQuiz className="icon" />
                  <span>Conformity Analysis</span>
                </NavLink>
              </li>
              <li>
                <NavLink 
                  to="/ThreatAnalysis" 
                  className={`menu-item `} 
                >
                  <MdQuiz className="icon" />
                  <span>Threat Analysis</span>
                </NavLink>
              </li>
              <li>
                <NavLink 
                  to="/AIPolicyPro" 
                  className={`menu-item `} 
                >
                  <IoIosDocument className="icon" />
                  <span>AI Policy Pro</span>
                </NavLink>
              </li>
            {dashboardOpen && (
              <li>
                <NavLink 
                  to="/dashboard" 
                  className={`menu-item `} 
                >
                  <LuLayoutDashboard className="icon" />
                  <span>Dashboard</span>
                </NavLink>
              </li>
            )}
            <li>
                <NavLink 
                  to="/ThreatIntel" 
                  className={`menu-item `} 
                >
                  <AiFillSecurityScan className="icon" />
                  <span>Threat Intelligence</span>
                </NavLink>
              </li>
               <li>
                <NavLink 
                  to="/AIRiskDatabase" 
                  className={`menu-item `} 
                >
                  <AiFillSecurityScan className="icon" />
                  <span>AI Risk Database</span>
                </NavLink>
              </li>
              <li>
                <NavLink 
                  to="/DataProfiler" 
                  className={`menu-item `} 
                >
                  <AiFillProfile className="icon" />
                  <span>Data Profiler</span>
                </NavLink>
              </li>
              <li>
                <NavLink 
                  to="/DataSecurity" 
                  className={`menu-item `} 
                >
                  <FaUserLock className="icon" />
                  <span>Data Security</span>
                </NavLink>
              </li>
              <li>
                <NavLink 
                  to="/SecAIPage" 
                  className={`menu-item `} 
                >
                  <BsStars className="icon" />
                  <span>SecAI</span>
                </NavLink>
              </li>
              <li>
                <NavLink 
                  to="/ModelEvaluation" 
                  className={`menu-item `} 
                >
                  <FaUserShield className="icon" />
                  <span>Model Evaluation</span>
                </NavLink>
              </li>
              <li>
                <NavLink 
                  to="/PrivacyMeter" 
                  className={`menu-item `} 
                >
                  <FaUnlockAlt className="icon" />
                  <span>Privacy Meter</span>
                </NavLink>
              </li>
              <li>
                <NavLink 
                  to="/FederatedLearning" 
                  className={`menu-item `} 
                >
                  <LuBrainCircuit className="icon" />
                  <span>Federated Learning</span>
                </NavLink>
              </li>
              <li>
                <NavLink 
                  to="/HomomorphicEncryption" 
                  className={`menu-item `} 
                >
                  <SiLetsencrypt className="icon" />
                  <span>Homomorphic Encryption</span>
                </NavLink>
              </li>
              <li>
                <NavLink 
                  to="/ATLAS"  
                  className={`menu-item `} 
                >
                  <GiSwordsEmblem className="icon" />
                  <span>ATLAS</span>
                </NavLink>
              </li>
              <li>
                <NavLink to="/Support" activeClassName="active">
                  <MdContactSupport className="icon" />
                  <span>Support Centre</span>
                </NavLink>
              </li>
              <li>
                <NavLink to="/ContactUs" activeClassName="active">
                  <FaPhoneAlt className="icon" />
                  <span>Contact Us</span>
                </NavLink>
              </li>
            {adminTrue && (
              <li>
                <NavLink 
                  to="/AdminDashboard" 
                  className={`menu-item `} 
                >
                  <MdManageAccounts className="icon" />
                  <span>Admin Dashboard</span>
                </NavLink>
              </li>
            )}
             <li>
                <NavLink 
                  to="/AccountManagement" 
                  className={`menu-item `} 
                >
                  <FaUser className="icon" />
                  <span>Account Management</span>
                </NavLink>
              </li>
            <li>
              <NavLink onClick={handleSignOut} to="" className="menu-item">
                <FaSignOutAlt className="icon" />
                <span>Sign Out</span>
              </NavLink>
            </li>
          </ul>
        </nav>
      </div>
      <button className="toggle-btn" onClick={toggleSidebar}><FaBars /></button>
    </>
  );
};

export default Sidebar;
